module.exports = __webpack_public_path__ + "static/img/til68.b177371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til68.jpg
// module id = uKHp
// module chunks = 1